import React, { FC } from 'react'

import Box from '../box/Box'
import { IllustrationBaseProps } from './Base'

const OnceUponLogo: FC<IllustrationBaseProps> = ({ width = '100%', height = '100%', ...props }) => {
  return (
    <Box {...props}>
      <svg fill="none" width={width} height={height} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
        <path
          d="m11.076 18.274c-0.8672 0.0785-1.7448 0.0715-2.6041-0.07-1.7647-0.29106-3.4286-1.1627-4.6723-2.4486-1.7185-1.7771-2.6965-4.4269-2.2818-6.889 0.38989-2.314 1.7811-4.5521 3.7192-5.8847 1.8427-1.2665 4.1031-1.9813 6.3406-1.9813 6.0749 0 11 4.9251 11 11s-4.9251 11-11 11c-1.6763 0-3.5771-0.18477-4.9122-1.3117-0.57962-0.48923-1.5437-1.4692-0.32085-1.9524 0.31241-0.12367 0.65015-0.11871 0.98889-0.0834 0.16192 0.0169 0.32383 0.0407 0.48327 0.0606 2.8733 0.3601 5.9433-0.70876 7.9757-2.8167 0.98541-1.0222 1.725-2.2728 2.1844-3.6138 0.50612-1.4781 0.96754-3.2235 0.64469-4.791-0.0313-0.15248-0.0755-0.30347-0.1341-0.45049-0.44999-1.1349-1.642-1.6713-2.6632-1.4801-1.0212 0.19123-1.8849 0.96208-2.5962 1.8338-0.39784 0.48725-0.87863 1.2174-1.7523 1.0867-0.67698-0.10132-1.0326-0.6884-1.3579-1.0867-0.71124-0.87167-1.575-1.6425-2.5961-1.8338-1.0212-0.19122-2.2137 0.3452-2.6632 1.4801-0.0586 0.14752-0.10282 0.29801-0.13411 0.45099-0.77929 3.7877 3.4028 6.5532 6.5502 7.3742 0.47632 0.12417 1.0043 0.24337 1.2973 0.63923 0.78922 1.0639-0.69834 1.6967-1.496 1.7687z"
          strokeWidth=".049668"
          fill="currentColor"
        />
      </svg>
    </Box>
  )
}

export default OnceUponLogo
